import React from 'react';
import ClaimFieldsTable from './ClaimFieldsTable';
export default function TaxBenefitTable(_ref) {
  let {
    claim,
    calculations,
    setClaim,
    refreshCalculations
  } = _ref;
  const taxBenefitSummaryRows = [{
    text: '(additional) Tax refund due',
    field: {
      name: 'benefit_additional_tax_refund_due'
    }
  }, {
    text: 'Tax reduction',
    field: {
      name: 'benefit_tax_reduction'
    }
  }, {
    text: 'Capped R&D Tax Credit',
    field: {
      name: 'benefit_capped_rnd_tax_credit'
    }
  }, {
    text: 'Payable ERIS credit',
    field: {
      name: 'benefit_payable_eris_credit'
    },
    shouldDisplay: claim.rate_types_qualified_for.eris
  }, {
    text: 'Reduction in tax payable by Group company',
    field: {
      name: 'summary_reductions_in_tax_payable_by_group_company'
    }
  }, {
    text: 'Value of increased losses carried forward',
    field: {
      name: 'benefit_value_of_increased_losses_carried_forward'
    }
  }, {
    text: 'Old RDEC cash credit claimed',
    field: {
      name: 'rdec_scheme_benefit_cash_credit_claimed'
    },
    shouldDisplay: claim.rate_types_qualified_for.rdec
  }, {
    text: 'Old RDEC amounts carried forward',
    field: {
      name: 'rdec_scheme_amount_witheld_due_to_exceeding_cap'
    },
    shouldDisplay: claim.rate_types_qualified_for.rdec
  }, {
    text: 'Old RDEC amounts used to pay other liabilities',
    field: {
      name: 'summary_amount_other_liabilities'
    },
    shouldDisplay: claim.rate_types_qualified_for.rdec
  }, {
    text: 'RDEC Merged Scheme cash credit claimed',
    field: {
      name: 'merged_scheme_benefit_cash_credit_claimed'
    },
    shouldDisplay: claim.rate_types_qualified_for.merge_type
  }, {
    text: 'RDEC Merged Scheme amounts carried forward',
    field: {
      name: 'merged_scheme_amount_witheld_due_to_exceeding_cap'
    },
    shouldDisplay: claim.rate_types_qualified_for.merge_type
  }, {
    text: 'RDEC Merged Scheme amounts used to pay other liabilities',
    field: {
      name: 'summary_amount_other_liabilities'
    },
    shouldDisplay: claim.rate_types_qualified_for.merge_type
  }, {
    text: 'TOTAL BENEFIT',
    field: {
      name: 'summary_total_benefit'
    }
  }];
  return /*#__PURE__*/React.createElement(ClaimFieldsTable, {
    calculations: calculations,
    refreshCalculations: refreshCalculations,
    claim: claim,
    setClaim: setClaim,
    title: "Tax Benefit Summary",
    rows: taxBenefitSummaryRows
  });
}